import { Navigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const NavigateToEditShiftTemplatePage = () => {
  const params = useParams()
  const { navigation } = useNavigation()
  const to = navigation.shifts.templates.templatesShiftTemplateId.edit.fullPath({
    shiftTemplateId: params.shiftTemplateId ?? '',
  })

  return <Navigate replace to={to} />
}

export default NavigateToEditShiftTemplatePage
